function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.6139 0.5C14.8167 0.5 16.6523 2.33567 16.6523 4.53846C16.6523 6.74126 14.8167 8.57693 12.6139 8.57693C10.4111 8.57693 8.57541 6.74126 8.57541 4.53846C8.57541 2.33567 10.4111 0.683567 12.6139 0.5ZM12.6139 6.74126C13.8988 6.74126 14.8167 5.82343 14.8167 4.53846C14.8167 3.2535 13.8988 2.33567 12.6139 2.33567C11.3289 2.33567 10.4111 3.43706 10.4111 4.53846C10.4111 5.82343 11.3289 6.74126 12.6139 6.74126Z",
  fill: "#cccccc"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.2982 0.5C41.0954 0.5 39.2598 2.33567 39.2598 4.53846C39.2598 6.74126 41.0954 8.57693 43.2982 8.57693C45.501 8.57693 47.3367 6.74126 47.3367 4.53846C47.3367 2.33567 45.501 0.683567 43.2982 0.5ZM43.2982 6.74126C42.0133 6.74126 41.0954 5.82343 41.0954 4.53846C41.0954 3.2535 42.0133 2.33567 43.2982 2.33567C44.5832 2.33567 45.501 3.43706 45.501 4.53846C45.501 5.82343 44.5832 6.74126 43.2982 6.74126Z",
  fill: "#cccccc"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.7197 24.7307H46.5274C51.4343 24.7307 55.412 28.7085 55.412 33.6153C55.412 38.5222 51.4343 42.5 46.5274 42.5H45.7197V24.7307Z",
  fill: "#cccccc"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.1924 24.7307H9.38469C4.47785 24.7307 0.500069 28.7085 0.500069 33.6153C0.500069 38.5222 4.47785 42.5 9.38469 42.5H10.1924V24.7307Z",
  fill: "#cccccc"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.9521 10.1924C36.0287 10.1929 45.7197 14.2321 45.7197 27.1543V44.9229C45.4505 47.6151 41.52 52.9986 27.9521 52.999V53L27.9512 52.999L27.9502 53V52.999C14.3823 52.9986 10.4518 47.6151 10.1826 44.9229V27.1543C10.1826 14.2321 19.8736 10.1929 27.9502 10.1924H27.9521Z",
  fill: "#65A30D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4143 16.444C12.8004 17.2434 12.2571 18.1319 11.7991 19.1158V8.57678H13.4143V16.444Z",
  fill: "#cccccc"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.4927 16.4434C43.1067 17.243 43.6498 18.132 44.1079 19.1162V8.57715H42.4927V16.4434Z",
  fill: "#cccccc"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.95264 41.9392C6.8355 42.3056 7.78998 42.5317 8.78955 42.5945C11.0494 44.2903 14.1826 45.6707 18.2417 45.6707V47.3464C12.4371 47.3464 8.36726 44.6246 5.95264 41.9392Z",
  fill: "#cccccc"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.3014 42.5001C24.5042 42.5001 26.3398 44.3358 26.3398 46.5386C26.3398 48.7414 24.5042 50.5771 22.3014 50.5771C20.0986 50.5771 18.2629 48.7414 18.2629 46.5386C18.2629 44.3358 20.0986 42.6837 22.3014 42.5001ZM22.3014 48.7414C23.5863 48.7414 24.5042 47.8236 24.5042 46.5386C24.5042 45.2536 23.5863 44.3358 22.3014 44.3358C21.0164 44.3358 20.0986 45.4372 20.0986 46.5386C20.0986 47.8236 21.0164 48.7414 22.3014 48.7414Z",
  fill: "#cccccc"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.1839 24.0017C36.1839 24.0017 31.0455 24.0017 21.6495 24.0017C12.8408 24.0017 13.428 31.043 13.428 31.043C13.428 38.9833 20.3282 38.5338 20.1814 38.5338H36.3308C36.3308 38.5338 42.4969 38.384 42.4969 31.043C42.4969 23.7021 36.1839 24.0017 36.1839 24.0017ZM19.4474 33.8895C17.9792 33.8895 16.8047 32.691 16.8047 31.1929C16.8047 29.6947 17.9792 28.4962 19.4474 28.4962C20.9155 28.646 22.09 29.6947 22.09 31.1929C22.09 32.691 20.9155 33.8895 19.4474 33.8895ZM27.9625 36.1368C24.1453 36.1368 24.7326 32.5412 24.7326 32.5412H31.1923C31.1923 32.5412 32.0732 36.1368 27.9625 36.1368ZM36.3308 33.8895C34.8626 33.8895 33.6881 32.691 33.6881 31.1929C33.6881 29.6947 34.8626 28.4962 36.3308 28.4962C37.7989 28.646 38.9734 29.6947 38.9734 31.1929C38.9734 32.691 37.7989 33.8895 36.3308 33.8895Z",
  fill: "#cccccc"
});

var SvgChatBotAiLight = function SvgChatBotAiLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChatBotAiLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_bot_ai_light.d7792fc8.svg";
export { ForwardRef as ReactComponent };